/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { BooleanSearch } from './BooleanSearch';
import {
    BooleanSearchFromJSON,
    BooleanSearchFromJSONTyped,
    BooleanSearchToJSON,
} from './BooleanSearch';
import type { UnaccentTextSearch } from './UnaccentTextSearch';
import {
    UnaccentTextSearchFromJSON,
    UnaccentTextSearchFromJSONTyped,
    UnaccentTextSearchToJSON,
} from './UnaccentTextSearch';

/**
 * 
 * @export
 * @interface LieuFormationSearchDto
 */
export interface LieuFormationSearchDto {
    /**
     * 
     * @type {number}
     * @memberof LieuFormationSearchDto
     */
    idsiegeSocial?: number | null;
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof LieuFormationSearchDto
     */
    nom?: UnaccentTextSearch;
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof LieuFormationSearchDto
     */
    enseigne?: UnaccentTextSearch;
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof LieuFormationSearchDto
     */
    contact?: UnaccentTextSearch;
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof LieuFormationSearchDto
     */
    localite?: UnaccentTextSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof LieuFormationSearchDto
     */
    mesLieuxFormation?: BooleanSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof LieuFormationSearchDto
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof LieuFormationSearchDto
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof LieuFormationSearchDto
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LieuFormationSearchDto
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof LieuFormationSearchDto
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof LieuFormationSearchDto
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the LieuFormationSearchDto interface.
 */
export function instanceOfLieuFormationSearchDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LieuFormationSearchDtoFromJSON(json: any): LieuFormationSearchDto {
    return LieuFormationSearchDtoFromJSONTyped(json, false);
}

export function LieuFormationSearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LieuFormationSearchDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idsiegeSocial': !exists(json, 'idsiegeSocial') ? undefined : json['idsiegeSocial'],
        'nom': !exists(json, 'nom') ? undefined : UnaccentTextSearchFromJSON(json['nom']),
        'enseigne': !exists(json, 'enseigne') ? undefined : UnaccentTextSearchFromJSON(json['enseigne']),
        'contact': !exists(json, 'contact') ? undefined : UnaccentTextSearchFromJSON(json['contact']),
        'localite': !exists(json, 'localite') ? undefined : UnaccentTextSearchFromJSON(json['localite']),
        'mesLieuxFormation': !exists(json, 'mesLieuxFormation') ? undefined : BooleanSearchFromJSON(json['mesLieuxFormation']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function LieuFormationSearchDtoToJSON(value?: LieuFormationSearchDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idsiegeSocial': value.idsiegeSocial,
        'nom': UnaccentTextSearchToJSON(value.nom),
        'enseigne': UnaccentTextSearchToJSON(value.enseigne),
        'contact': UnaccentTextSearchToJSON(value.contact),
        'localite': UnaccentTextSearchToJSON(value.localite),
        'mesLieuxFormation': BooleanSearchToJSON(value.mesLieuxFormation),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

